import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import RelayEnvironment from "./relay/RelayEnvironment";
import { RelayEnvironmentProvider } from 'react-relay';
import {QueriesProvider} from "./components/QueriesProvider";
import {BrowserRouter} from "react-router-dom";
import {AuthProvider} from "./components/auth/AuthProvider";
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RelayEnvironmentProvider environment={RelayEnvironment}>
      <BrowserRouter>
        <QueriesProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </QueriesProvider>
      </BrowserRouter>
    </RelayEnvironmentProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
